/**
 * Check if element has data-copy-url attribute and if so copy url to clipboard
 */

window.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", function handleCopyUrl(ev) {
    const el = ev.target.closest("[data-copy-url]");
    if (!el) return;

    copyToClipboard(window.location.href).then(() => {
      const hiddingClass = "sr-only";
      const copying = el.querySelector(".copying");
      const copied = el.querySelector(".copied");
      copying.classList.add(hiddingClass);
      copied.classList.remove(hiddingClass);
      setTimeout(() => {
        copying.classList.remove(hiddingClass);
        copied.classList.add(hiddingClass);
      }, 2000);
    });
  });
});

function copyToClipboard(txt) {
  return navigator.clipboard.writeText(txt).catch(() => {
    alert("Error: failed to copy to clipboard");
  });
}
